import { useState, useEffect, Fragment } from 'react';
import Layout from '../../components/layout';
import TimesheetWeek from '../../api/models/timesheetWeek';
import TimesheetSummary from '../../api/models/timesheetSummary';
import TimesheetWeekEntries from '../../components/timesheetWeekEntries';
import { Notification } from '../../components/notifications';
import { useHistory, useLocation } from 'react-router';
import EditModal from '../../components/editModal';
import TimesheetWeekTask from '../../api/models/TimesheetWeekTask';
import { getTimesheetWeek, updateFlagStatus, updateTimesheet, updateTimesheetFlagStatus } from '../../api/services/timesheetApprovalProofingService';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import TimesheetFlag from '../../api/models/timesheetFlag';
import TimesheetWeekEntry from '../../api/models/TimesheetWeekEntry';
import { useAsync } from 'react-async';
import TimesheetEntryFlagRequest from '../../api/requests/timesheetEntryFlagRequest';
import TimesheetFlagRequest from '../../api/requests/timesheetFlagRequest';
import { TaskTypeLookup, TimesheetFlagStatus, TimesheetStatus } from '../../common/constants';
import TimesheetEntryFlag from '../../api/models/timesheetEntryFlag';
import { ArrowCircleLeftIcon } from '@heroicons/react/outline';
import TimesheetSubmitRequest from '../../api/requests/timesheetSubmitRequest';
import DataTable from '../../components/dataTable';
import React from 'react';
import SelectMulti from 'react-select';
import SubmitButton from '../../components/submitButton';
import ProofingNotes from '../../components/ProofingNotes';
import { sortAlphabetically, removeDuplicates } from '../../common/utils';
import Student from '../../api/models/student';
import EditEntry from '../../components/logTimeModal/types/editEntry';


type Params = {
  id: string;
};

const fetchWeek = async (args: any) => await getTimesheetWeek(Number(args[0]));

class FlagRow {
  id?: number;
  type?: string = "";
  discipline?: string = "";
  therapist?: string = "";
  school?: string = "";
  entry?: string = "";
  task?: string = "";
  date?: string = "";
  mins?: string = "";
  flag?: string = "";
  feedback?: string = "";
  students?: Student[] = [];

  district?: string = "";

  fullEntry?: TimesheetWeekEntry;
  fullTask?: TimesheetWeekTask;
  fullEntryFlag?: TimesheetEntryFlag;
  fullTimesheetFlag?: TimesheetFlag;

  weekId?: number = 0;
  compareDate?: number = 0;
};
const ProofingDetail = () => {
  const columns = React.useMemo(
    () => [
      {
        accessor: 'id',
        width: 30,
        disableSortBy: true,
        autoResetSortBy: false,
        Header: (props: any) => {
          return (
            <input
              type='checkbox'
              onChange={(e) => {
                const checkboxes = document.querySelectorAll('.datatable-checkbox');

                checkboxes.forEach((checkbox: any) => {
                  if (e.currentTarget.checked) {
                    if (!checkbox.checked) checkbox.click();
                  } else {
                    if (checkbox.checked) checkbox.click();
                  }
                });
              }}
            />
          )
        },
        Cell: (props: any) => {
          return (
            <input
              className='datatable-checkbox'
              value={(props.row.original as FlagRow).id}
              type='checkbox'
              onChange={(e) => {
                const checkboxes = document.querySelectorAll('.datatable-checkbox');
                let anyOn = false;
                checkboxes.forEach((checkbox: any) => {
                  if (checkbox.checked) {
                    anyOn = true;
                  }
                });
                if (anyOn) {
                  setSelectedCount(1);
                } else {
                  setSelectedCount(0);
                }
              }}
            />
          )
        }
      },
      {
        id: 'disciplineColumn',
        Header: 'Discipline',
        accessor: 'discipline',
        autoResetSortBy: false
      },
      {
        id: 'therapistColumn',
        Header: 'Therapist',
        accessor: 'therapist',
        autoResetSortBy: false
      },
      {
        id: 'schoolColumn',
        Header: 'School',
        accessor: 'school',
        autoResetSortBy: false
      },
      {
        id: 'entryColumn',
        Header: 'Entry',
        accessor: 'entry',
        autoResetSortBy: false
      },
      {
        id: 'taskColumn',
        Header: 'Task',
        accessor: 'task',
        autoResetSortBy: false
      },
      {
        id: 'dateColumn',
        Header: 'Date',
        accessor: 'date',
        autoResetSortBy: false,
        sortType: (rowA: any, rowB: any, id: string, desc: any) => {
          return rowA.original.compareDate - rowB.original.compareDate;
        }
      },
      {
        id: 'minsColumn',
        Header: 'Mins',
        accessor: 'mins',
        autoResetSortBy: false
      },
      {
        id: 'flagColumn',
        Header: 'Flag',
        accessor: 'flag',
        autoResetSortBy: false
      },
      {
        id: 'actionColumn',
        Header: 'Actions',
        disableSortBy: true,
        Cell: (props: any) => {
          let row = props.row.original as FlagRow;
          return (
            <div>
              <div><a href="#" onClick={(e) => { handleApprove(e, row); }}>Approve</a></div>
              <div><a href="#" onClick={(e) => { handleReject(e, row); }}>Reject</a></div>
              <div><a href="#" onClick={(e) => { handleRejectWFeedback(e, row); }}>Reject w/Feedback</a></div>
            </div>
          )
        }
      },
      {
        id: 'feedbackColumn',
        Header: 'Rejection Feedback',
        accessor: 'feedback',
      },
    ],
    []);

  //constants
  const { id } = useParams<Params>();
  const history = useHistory();
  const location = useLocation();
  const defaultSort = React.useMemo(
    () => [
      {
        id: "disciplineColumn",
        desc: false,
        autoResetSortBy: false
      }
    ],
    []
  );
  const [initialState, setInitialState] = useState<{}>({ sortBy: defaultSort, sortType: "ci" });
  //Timesheet hooks
  const [timesheet, setTimesheet] = useState<TimesheetSummary>();
  const [timesheetStatusId, setTimesheetStatusId] = useState<number>(-1);
  const [week, setWeek] = useState<TimesheetWeek>();
  const [studentData, setStudentData] = useState<Student[]>();
  const [discipline, setDiscipline] = useState<string>("");
  const [task, setTask] = useState<TimesheetWeekTask>();
  const [entry, setEntry] = useState<TimesheetWeekEntry>();
  const [entryFlag, setEntryFlag] = useState<TimesheetEntryFlag>();
  const [feedback, setFeedback] = useState('');
  const [timesheetFlag, setTimesheetFlag] = useState<TimesheetFlag>();
  const [rejectionTimesheet, setRejectionTimesheet] = useState<TimesheetSummary>();

  //Control vars
  const [cancelButtonOnly, setCancelButtonOnly] = useState<boolean>(false);
  const [switchLabel, setSwitchLabel] = useState<string>("Switch to List View");
  const [activeView, setActiveView] = useState<string>("grid");
  const [flags, setFlags] = useState<FlagRow[]>([]);
  //Informational hooks
  const [openReviewEntryModal, setOpenReviewEntryModal] = useState<boolean>(false);
  const [openTimesheetFlagModal, setOpenTimesheetFlagModal] = useState<boolean>(false);
  const [openTimesheetRejectionModal, setOpenTimesheetRejectionModal] = useState<boolean>(false);

  const [districtOptions, setDistrictOptions] = useState<{ label: string, value: string }[]>([]);
  const [district, setDistrict] = useState<string>("-1");

  const [flagOptions, setFlagOptions] = useState<{ label: string, value: string }[]>([]);
  const [flag, setFlag] = useState<string>("-1");

  const [schoolOptions, setSchoolOptions] = useState<{ label: string, value: string }[]>([]);
  const [school, setSchool] = useState<string>("-1");

  const [originalFlags, setOriginalFlags] = useState<FlagRow[]>([]);
  const [selectedCount, setSelectedCount] = useState<number>(0);
  const [selectedFlag, setSelectedFlag] = useState<FlagRow>();
  const [entryFlagAction, setEntryFlagAction] = useState<string>();
  const [isPending, setIsPending] = useState<boolean>(false);
  const [isNoteReview, setIsNoteReview] = useState<boolean>(false);

  const parseResponse = () => {
    var therapistOptions: { label: string, value: string }[] = [];
    var districtOptions: { label: string, value: string }[] = [];
    var flagOptions: { label: string, value: string }[] = [];
    var schoolOptions: { label: string, value: string }[] = [];
    var flags: FlagRow[] = [];

    var parsed = parseTimesheet(timesheet!, therapistOptions, districtOptions, flagOptions, schoolOptions);

    therapistOptions = parsed.therapistOptions;
    districtOptions = parsed.districtOptions;
    flagOptions = parsed.flagOptions;
    schoolOptions = parsed.schoolOptions;

    flags = flags.concat(parsed.flags);


    setFlags(flags);
    setOriginalFlags(flags);
    setDistrictOptions(districtOptions);
    setSchoolOptions(schoolOptions);
    setFlagOptions(flagOptions);

  };

  const parseTimesheet = (el: TimesheetSummary, therapistOptions: { label: string, value: string }[], districtOptions: { label: string, value: string }[], flagOptions: { label: string, value: string }[], schoolOptions: { label: string, value: string }[]) => {
    var flags: FlagRow[] = [];
    let weekStart = week !== undefined ? new Date(week.firstDayOfWeek) : undefined;
    let weekEnd = week !== undefined ? new Date(week.lastDayOfWeek) : undefined;

    el?.weeks?.forEach((wk) => {
      wk.items?.forEach((i) => {
        i.tasks?.forEach((t) => {
          t.entries?.forEach((e) => {
            if (e.timesheetEntryFlags.length > 0) {

              let d = new Date(e.dateOfEntry);
              if (weekStart !== undefined && weekEnd !== undefined && !((d >= weekStart) && (d <= (weekEnd)))) {
                return;
              }
              e.timesheetEntryFlags.forEach((ef) => {

                let flag = new FlagRow();
                flag.fullEntry = e;
                flag.fullTask = t;
                flag.fullEntryFlag = ef;
                flag.weekId = wk.weekId;
                flag.students = i.studentData;
                let name = el.therapist?.user?.lastName + ", " + el.therapist?.user?.firstName;
                let dis = i.description ?? el.district?.name;
                let discipline = el.therapist?.discipline?.name;
                let fl = ef.proofingRule.name;
                let school = i.subTitle;

                flag.id = ef.timesheetEntryFlagId;
                flag.type = "entry";
                flag.district = dis;
                flag.discipline = discipline;
                flag.therapist = name;

                if (therapistOptions.filter(e => e.label === name).length == 0) {
                  therapistOptions.push({ label: name, value: name });
                }
                if (districtOptions.filter(e => e.label === dis).length == 0) {
                  districtOptions.push({ label: dis ?? "", value: dis ?? "" });
                }
                if (flagOptions.filter(e => e.label === fl).length == 0) {
                  flagOptions.push({ label: fl, value: fl });
                }
                if (schoolOptions.filter(e => e.label === school).length == 0) {
                  schoolOptions.push({ label: school, value: school });
                }

                flag.school = school;
                flag.entry = t.entryTypeName.toString();
                flag.task = t.taskTypeName.toString();
                flag.flag = fl;
                flag.mins = e.minutes?.toString() ?? '0';
                flag.feedback = ef.feedback === '' ? ef.flagNote : ef.feedback;

                flag.date = (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear();
                flag.compareDate = parseInt(moment(flag.date!).format("YYYYMMDD"));
                flags.push(flag);
              });
            }
          });
        });
      });
    });

    return {
      flags: flags,
      therapistOptions: therapistOptions,
      districtOptions: sortAlphabetically(districtOptions),
      flagOptions: sortAlphabetically(flagOptions),
      schoolOptions: sortAlphabetically(schoolOptions),
    };
  };

  const handleSearch = () => {
    if (district != '-1' || flag != '-1' || school != '-1') {
      setFlags(originalFlags.filter((x: FlagRow) =>
        (district != '-1' ? x.district == district : true) &&
        (flag != '-1' ? x.flag == flag : true) &&
        (school != '-1' ? x.school == school : true)
      ));
    } else {
      setFlags(originalFlags);
    }
  };

  /**
   * Runs on render and grabs the week passed in throught the query string
   */
  const weekData = useAsync({
    deferFn: fetchWeek,
    onResolve: (response: any) => {
      if (response) {
        const timesheets: TimesheetSummary[] = response.data.timesheets;
        const timesheet: TimesheetSummary = timesheets[0];
        setTimesheet(timesheet);
        setTimesheetStatusId(timesheet?.status?.timesheetStatusId ?? timesheet?.timesheetStatusId ?? -1);
        setDiscipline(response.data.therapist?.discipline?.name);
      }
    }
  });

  //Updated the above to be a deferFn so that it can be run after the first
  //load. This is why we have this effect to run when the id changes
  useEffect(() => { if (id) weekData.run(id) }, [id]);
  useEffect(() => {
    if (activeView == "list") {
      setDistrict("-1");
      setFlag("-1");
      setSchool("-1");
    }
    if (id /*&& activeView === 'grid'*/) weekData.run(id);
  }, [activeView]);
  useEffect(() => {

    if (timesheet != undefined) {
      let week = timesheet?.weeks.find((w: any) => w.firstDayOfWeek === timesheet.weekModel?.firstDayOfWeek);

      if (week !== undefined) {
        setWeek(week);
      }

    }

  }, [timesheet]);
  useEffect(() => {

    if (activeView == "list") {
      parseResponse();
    }
  }, [week]);

  useEffect(() => {


    handleSearch();
  }, [originalFlags]);
  /**
   * This effect runs every time the timesheet is updated.
   * It runs on load and every time a flag is changed.
   */



  /**
   * Handles a click on the timesheet entry.
   * Argument is a week item
   * @param editEntry
   */
  const handleModal = (editEntry: EditEntry, isNoteReview = false) => {
    setIsNoteReview(isNoteReview);
    setStudentData(editEntry.studentData);
    setTask(editEntry.task);
    setEntry(editEntry.entry);

    //if there is only one flag open that flag, otherwise set it to undefined 
    //so the user can select the flag from a list
    if (typeof editEntry!.entry?.timesheetEntryFlags?.length !== "undefined" && editEntry.entry.timesheetEntryFlags.length === 1)
      setEntryFlag(editEntry.entry.timesheetEntryFlags[0]);
    else
      setEntryFlag(undefined);

    setFeedback(editEntry?.entry?.timesheetEntryFlags[0] && editEntry?.entry?.timesheetEntryFlags[0] !== undefined ? editEntry?.entry?.timesheetEntryFlags[0].feedback : '');
    setOpenReviewEntryModal(editEntry?.entry?.timesheetEntryFlags[0] !== undefined);
  }

  /**
   * Handles a click on the timesheet.
   * Argument is a week item
   * @param editEntry
   */
  const handleTimesheetFlagModal = (editEntry: any, cancelOnly: boolean = false) => {
    setTimesheetFlag(editEntry);
    setOpenTimesheetFlagModal(true);
    if (cancelOnly) {
      setCancelButtonOnly(true);
    } else {
      setCancelButtonOnly(false);
    }
  }

  const handleQuickApprove = (editEntry: any) => {
    setFeedback('');
    setTimesheetFlag(editEntry);
    approveTimesheetFlag.run(editEntry);
  }

  const handleQuickReject = (editEntry: any) => {
    setFeedback('');
    setTimesheetFlag(editEntry);
    rejectTimesheetFlag.run(editEntry);
  }


  /**
   * Approval Logic
   */
  const doApprove = async () => {

    if (entryFlag === undefined)
      return Promise.reject("Entry Flag was missing");

    //Create our request
    const request: TimesheetEntryFlagRequest = {
      timesheetEntryFlagId: entryFlag.timesheetEntryFlagId!,
      timesheetEntryFlagStatusId: TimesheetFlagStatus.Approved,
      timesheetWeekId: Number(id),
      feedback: feedback
    }

    //Wait for our response
    const response = await updateFlagStatus(request);

    //Process the updated timesheet 
    const timesheets: TimesheetSummary[] = response.data.result.timesheets;
    const timesheet: TimesheetSummary = timesheets[0];
    setTimesheet({ ...timesheet });
    setTimesheetStatusId(timesheet?.status?.timesheetStatusId ?? timesheet?.timesheetStatusId ?? -1);

    //Close the modal
    //setOpenReviewEntryModal(false);
    setEntryFlag(undefined);
    setFeedback('');
    return Promise.resolve();
  }
  const approve = useAsync({
    deferFn: doApprove,
  });

  /**
   * Rejection Logic
   */
  const doReject = async () => {
    if (entryFlag === undefined)
      return Promise.reject("Entry Flag was missing");

    //Create our request
    const request: TimesheetEntryFlagRequest = {
      timesheetEntryFlagId: entryFlag.timesheetEntryFlagId!,
      timesheetEntryFlagStatusId: TimesheetFlagStatus.Rejected,
      timesheetWeekId: Number(id),
      feedback: feedback
    }

    //Wait for our response
    const response = await updateFlagStatus(request);

    //Process the updated timesheet
    const timesheets: TimesheetSummary[] = response.data.result.timesheets;
    const timesheet: TimesheetSummary = timesheets[0];
    setTimesheet({ ...timesheet });
    setTimesheetStatusId(timesheet?.status?.timesheetStatusId ?? timesheet?.timesheetStatusId ?? -1);

    //Close the modal
    //setOpenReviewEntryModal(false);
    setEntryFlag(undefined);
    setFeedback('');
    return Promise.resolve();
  }
  const reject = useAsync({
    deferFn: doReject,
  });

  /**
   * Timesheet Flag Approval Logic
   */
  const doApproveTimesheetFlag = async (args: any) => {
    const flag: TimesheetFlag = args === undefined || args.length === 0 ? timesheetFlag : args[0];

    //Create our request
    const request: TimesheetFlagRequest = {
      timesheetFlagId: flag.timesheetFlagId,
      timesheetFlagStatusId: TimesheetFlagStatus.Approved,
      timesheetWeekId: Number(id),
      feedback: feedback
    }

    //Wait for our response
    const response = await updateTimesheetFlagStatus(request);

    //Process the updated timesheet
    const timesheets: TimesheetSummary[] = response.data.result.timesheets;
    const timesheet: TimesheetSummary = timesheets[0];
    setTimesheet({ ...timesheet });
    setTimesheetStatusId(timesheet?.status?.timesheetStatusId ?? timesheet?.timesheetStatusId ?? -1);
    setFeedback('');

    //Close the modal
    //setOpenTimesheetFlagModal(false);
    return Promise.resolve();
  }
  const approveTimesheetFlag = useAsync({ deferFn: doApproveTimesheetFlag });

  /**
   * Timesheet Flag Rejection Logic
   */
  const doRejectTimesheetFlag = async (args: any) => {
    const flag: TimesheetFlag = args === undefined || args.length === 0 ? timesheetFlag : args[0];

    //Create our request
    const request: TimesheetFlagRequest = {
      timesheetFlagId: flag.timesheetFlagId,
      timesheetFlagStatusId: TimesheetFlagStatus.Rejected,
      timesheetWeekId: Number(id),
      feedback: feedback
    }

    //Wait for our response
    const response = await updateTimesheetFlagStatus(request);

    //Process the updated timesheet
    const timesheets: TimesheetSummary[] = response.data.result.timesheets;
    const timesheet: TimesheetSummary = timesheets[0];
    setTimesheet({ ...timesheet });
    setTimesheetStatusId(timesheet?.status?.timesheetStatusId ?? timesheet?.timesheetStatusId ?? -1);
    setFeedback('');

    //Close the modal
    //setOpenTimesheetFlagModal(false);
    return Promise.resolve();
  }
  const rejectTimesheetFlag = useAsync({ deferFn: doRejectTimesheetFlag });

  /**
   * Timesheet Rejection Logic
   */
  const doRejectTimesheet = async () => {
    const status = {
      timesheetStatusId: TimesheetStatus.Rejected ?? 0,
      name: TimesheetStatus[TimesheetStatus.Rejected]
    }

    //Create our submit request
    const request: TimesheetSubmitRequest = {
      timesheetId: timesheet?.timesheetId,
      timesheetStatus: status,
      feedback: feedback
    }

    //Wait for our response
    const response = await updateTimesheet(Number(id), request);

    //Process the updated timesheet
    const timesheets: TimesheetSummary[] = response.data.timesheets ?? response.data.result.timesheets;
    const newTimesheet: TimesheetSummary = timesheets[0];
    setTimesheet({ ...newTimesheet });
    setTimesheetStatusId(timesheet?.status?.timesheetStatusId ?? timesheet?.timesheetStatusId ?? -1);
    setFeedback('');

    //Close the modal
    //setOpenTimesheetFlagModal(false);
    return Promise.resolve(timesheet);
  }
  const rejectTimesheet = useAsync({ deferFn: doRejectTimesheet });

  const handleTimesheetReject = () => {
    if (timesheet?.status.timesheetStatusId !== TimesheetStatus.Rejected)
      rejectTimesheet.run();
  }

  const updateFlag = async (request: TimesheetEntryFlagRequest) => {
    //Wait for our response
    return await updateFlagStatus(request);
  }


  const rejectMulti = useAsync({
    deferFn: async () => {
      const checkboxes = document.querySelectorAll('.datatable-checkbox');
      let promises: Promise<void>[] = [];
      checkboxes.forEach((checkbox: any) => {
        if (checkbox.checked) {

          let flag = flags.find(x => x.id == checkbox.value);
          if (flag !== undefined) {
            let request: TimesheetEntryFlagRequest = {
              timesheetEntryFlagId: flag.id,
              timesheetEntryFlagStatusId: TimesheetFlagStatus.Rejected,
              timesheetWeekId: flag.weekId,
              feedback: feedback
            }
            promises.push(updateFlag(request).then((response) => {
              const timesheets: TimesheetSummary[] = response.data.result.timesheets;
              const timesheet: TimesheetSummary = timesheets[0];
              setTimesheet({ ...timesheet });
              setTimesheetStatusId(timesheet?.status?.timesheetStatusId ?? timesheet?.timesheetStatusId ?? -1);

              setEntryFlag(undefined);
              setFeedback('');

              checkbox.click();

              return new Promise<void>((resolve) => resolve());
            }));
          }
        }
      });
      return Promise.all(promises);
    }
  });

  const approveMulti = useAsync({
    deferFn: async () => {

      const checkboxes = document.querySelectorAll('.datatable-checkbox');
      let promises: Promise<void>[] = [];
      checkboxes.forEach((checkbox: any) => {
        if (checkbox.checked) {

          let flag = flags.find(x => x.id == checkbox.value);
          if (flag !== undefined) {
            let request: TimesheetEntryFlagRequest = {
              timesheetEntryFlagId: flag.id,
              timesheetEntryFlagStatusId: TimesheetFlagStatus.Approved,
              timesheetWeekId: flag.weekId,
              feedback: feedback
            }
            promises.push(updateFlag(request).then((response) => {
              const timesheets: TimesheetSummary[] = response.data.result.timesheets;
              const timesheet: TimesheetSummary = timesheets[0];
              setTimesheet({ ...timesheet });
              setTimesheetStatusId(timesheet?.status?.timesheetStatusId ?? timesheet?.timesheetStatusId ?? -1);


              setEntryFlag(undefined);
              setFeedback('');

              checkbox.click();

              return new Promise<void>((resolve) => resolve());
            }));
          }
        }
      });

      return Promise.all(promises);
    }
  });

  /**
   * Rejection Logic
   */
  const doRejectList = async () => {
    if (entryFlag === undefined)
      return Promise.reject("Entry Flag was missing");

    //Create our request
    const request: TimesheetEntryFlagRequest = {
      timesheetEntryFlagId: entryFlag.timesheetEntryFlagId!,
      timesheetEntryFlagStatusId: TimesheetFlagStatus.Rejected,
      timesheetWeekId: selectedFlag!.weekId,
      feedback: feedback
    }

    return updateFlag(request);

  }
  const rejectList = useAsync({
    deferFn: doRejectList,
    onResolve: (response) => {
      const timesheets: TimesheetSummary[] = response.data.result.timesheets;
      const timesheet: TimesheetSummary = timesheets[0];
      setTimesheet({ ...timesheet });
      setTimesheetStatusId(timesheet?.status?.timesheetStatusId ?? timesheet?.timesheetStatusId ?? -1);

      setEntryFlag(undefined);
      setFeedback('');
      //alert("Entry was rejected successfully.");
    }
  });

  /**
   * Approval Logic
   */
  const doApproveList = async () => {

    if (entryFlag === undefined)
      return Promise.reject("Entry Flag was missing");

    //Create our request
    const request: TimesheetEntryFlagRequest = {
      timesheetEntryFlagId: entryFlag.timesheetEntryFlagId!,
      timesheetEntryFlagStatusId: TimesheetFlagStatus.Approved,
      timesheetWeekId: selectedFlag!.weekId,
      feedback: feedback
    }

    return updateFlag(request);
  }
  const approveList = useAsync({
    deferFn: doApproveList,
    onResolve: (response) => {
      const timesheets: TimesheetSummary[] = response.data.result.timesheets;
      const timesheet: TimesheetSummary = timesheets[0];
      setTimesheet({ ...timesheet });
      setTimesheetStatusId(timesheet?.status?.timesheetStatusId ?? timesheet?.timesheetStatusId ?? -1);

      setEntryFlag(undefined);
      setFeedback('');

      //alert("Entry was approved successfully.");
    }
  });

  const handleRejectWFeedback = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, row: FlagRow) => {
    e.preventDefault();
    setSelectedFlag(row);
    if (row.students && row.students.length > 0) {
      setStudentData(row.students);
    }

    if (row.type == "entry") {
      setTask(row.fullTask);
      setEntry(row.fullEntry);
      setEntryFlagAction("reject_with_feedback");
      setEntryFlag(row.fullEntryFlag);
    } else {
      setTimesheetFlag(row.fullTimesheetFlag);
    }
    setOpenReviewEntryModal(true);
  };

  const handleApprove = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, row: FlagRow) => {
    e.preventDefault();
    setSelectedFlag(row);
    if (row.type === "entry") {
      setTask(row.fullTask);
      setEntry(row.fullEntry);
      setEntryFlagAction("approve");
      setEntryFlag(row.fullEntryFlag);
    } else {
      setTimesheetFlag(row.fullTimesheetFlag);
    }
  };

  /**
   * This effect will fire whenever the entryFlag hook is set
   * This is only for list view
   */
  useEffect(() => {

    if (entryFlag != undefined && activeView === 'list') {

      if (entryFlagAction === "approve") {
        approveList.run();
      } else if (entryFlagAction === "reject") {
        rejectList.run();
      }
    }
  }, [entryFlag]);

  const handleReject = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, row: FlagRow) => {
    e.preventDefault();
    setSelectedFlag(row);
    if (row.type === "entry") {
      setTask(row.fullTask);
      setEntry(row.fullEntry);
      setEntryFlagAction("reject");
      setEntryFlag(row.fullEntryFlag);
    } else {
      setTimesheetFlag(row.fullTimesheetFlag);
    }
  };

  /**
   * Proofing Note Approval function. This is kept outside of the
   * ProofingNotes component because every time it runs, it would cause a extra rerenders
   * 
   * We essentially create an array of promises for the proofing notes we want to approve
   * and then run that with Promise.All so they are all awaited before continuing
   * @param entry TimesheetWeekEntry[]
   */
  const approveProofingNote = async (entry: TimesheetWeekEntry[]) => {
    setIsPending(true);
    const promises: Promise<void>[] = [];

    //Loop through the entries and create a new promise for each approval
    entry.map((e) => e.timesheetEntryFlags.map(x => promises.push(new Promise((resolve) => resolve(doApproveProofingNote(x))))));

    //Perform the approvals
    await Promise.all(promises);
    setIsPending(false);
  };

  /**
   * Here we perform the actual approval of the proofing note
   */
  const doApproveProofingNote = async (flag: TimesheetEntryFlag) => {
    const request: TimesheetEntryFlagRequest = {
      timesheetEntryFlagId: flag.timesheetEntryFlagId!,
      timesheetEntryFlagStatusId: TimesheetFlagStatus.Approved,
      timesheetWeekId: flag.timesheetWeekId,
      feedback: flag.feedback
    }

    const response = await updateFlag(request);
    const timesheets: TimesheetSummary[] = response.data.result.timesheets;
    const timesheet: TimesheetSummary = timesheets[0];
    setTimesheet({ ...timesheet });
    setTimesheetStatusId(timesheet?.status?.timesheetStatusId ?? timesheet?.timesheetStatusId ?? -1);

    setEntryFlag(undefined);
    setFeedback('');
    //alert("Entry was approved successfully.");
  }

  return (
    <Layout
      isLoading={
        weekData.isPending ||
        approve.isPending ||
        reject.isPending ||
        approveTimesheetFlag.isPending ||
        rejectTimesheetFlag.isPending ||
        rejectTimesheet.isPending ||
        approveList.isPending ||
        rejectList.isPending ||
        approveMulti.isPending ||
        rejectMulti.isPending ||
        isPending
      }>
      <>
        {/* Review Entry Modal */}
        <EditModal
          open={openReviewEntryModal}
          onSave={() => {
            if (!isNoteReview) {
              approve.run();
            } else {
              reject.run();
            }

            setOpenReviewEntryModal(false);
          }}
          saveText={isNoteReview ? 'Reject' : 'Approve'}
          saveColor={isNoteReview ? `text-white bg-red-500 hover:bg-red-500` : `text-white bg-ptsgreen-500 hover:bg-ptsgreen-500`}
          onRemove={!isNoteReview ? () => { reject.run(); setOpenReviewEntryModal(false) } : undefined}
          removeText={!isNoteReview ? 'Reject' : undefined}
          removeColor='text-white bg-red-500 hover:bg-red-500'
          onCancel={() => { setFeedback(''); setOpenReviewEntryModal(false) }}
          allowSave={isNoteReview ? (feedback !== null && feedback !== undefined && feedback !== '') : true}
          allowRemove={!isNoteReview ? (feedback !== null && feedback !== undefined && feedback !== '') : undefined}
        >
          <Fragment>
            {entryFlag &&
              entry?.timesheetEntryFlags &&
              entry?.timesheetEntryFlags !== undefined &&
              entry?.timesheetEntryFlags.length > 1 && (
                <ArrowCircleLeftIcon
                  className='w-6 mt-1 mr-1 text-sm text-gray-800 cursor-pointer hover:underline hover:underline-offset-4'
                  onClick={() => setEntryFlag(undefined)}
                />
              )}
            <h3>{isNoteReview ? `Note Review` : `Review Entry`}</h3>

            {!entryFlag && (
              <div>
                <span>Please select a flag</span>
                <ul className="list-disc pl-7">
                  {entry?.timesheetEntryFlags.map((flag, i) => (
                    <li
                      className='text-sm cursor-pointer hover:underline hover:underline-offset-4'
                      key={`flagop_${i}`}
                      onClick={() => { setEntryFlag(flag); }}
                    > {flag.proofingRule.name} [{flag.timesheetFlagStatus && flag.timesheetFlagStatus !== null && flag.timesheetFlagStatus !== undefined ? flag.timesheetFlagStatus.name : ''}] </li>
                  ))}
                </ul>
              </div>
            )}

            {entryFlag && (
              <Fragment>
                <div className='grid grid-cols-3 gap-4 mt-2'>
                  <div className=''>
                    <div className='text-sm font-bold'>Therapist</div>
                    <div className='text-xs'>
                      <div>{timesheet?.therapist?.user?.lastName}, {timesheet?.therapist?.user?.firstName}</div>
                      <div className='italic'>{timesheet?.therapist?.discipline?.name}</div>
                    </div>
                  </div>
                  <div className=''>
                    <div className='text-sm font-bold'>{isNoteReview ? `Location` : `School`}</div>
                    <div>
                      <div className='text-sm'>{
                        task?.subTitle === null ||
                          task?.subTitle === undefined ||
                          task?.subTitle === '' ?
                          (task?.schoolName === undefined ||
                            task?.schoolName === null ? 'N/A' :
                            task?.schoolName) :
                          task?.subTitle}
                      </div>
                      <div className='text-sm'>{
                        timesheet === null ||
                        timesheet === undefined ||
                        (timesheet.district === undefined ||
                          timesheet.district === null ? 'N/A' :
                          timesheet.district.name)}
                      </div>
                    </div>
                  </div>
                  <div className=''>
                    <div className='text-sm font-bold'>Rule</div>
                    <div className='text-sm font-bold text-red-500'>
                      {entryFlag && entryFlag !== undefined ?
                        entryFlag.proofingRule.name
                        :
                        ((timesheetFlag && timesheetFlag !== undefined) &&
                          (timesheetFlag.proofingRule && timesheetFlag.proofingRule !== undefined) ?
                          timesheetFlag.proofingRule.name : '')
                      }
                    </div>
                  </div>
                </div>

                <div className='grid grid-cols-3 gap-4 mt-2'>
                  <div className=''>
                    <div className='text-sm font-bold'>Task Type</div>
                    <div className='text-xs'>
                      {task?.taskTypeName !== '' ? task?.taskTypeName : 'N/A'}
                    </div>
                  </div>

                  {(studentData || (task?.entries[0] && task?.entries[0].parentWeekItem?.studentData)) && (task?.taskTypeId !== TaskTypeLookup.ClinicalSupervision && task?.taskTypeId !== TaskTypeLookup.Mtss && task?.taskTypeId !== TaskTypeLookup.Other) && <div className=''>
                    <div className='text-sm font-bold'>Student{studentData && studentData?.length > 0 ? '(s)' : ''}</div>
                    <div className='text-xs'>
                      {(studentData || (task?.entries[0] && task?.entries[0].parentWeekItem?.studentData)) && removeDuplicates(studentData ?? task?.entries[0].parentWeekItem?.studentData ?? [], 'studentId').map((student) => (
                        <div key={`student_${student.studentId}`}>{student.lastName}, {student.firstName} (Grade: {student.grade})</div>
                      ))}
                    </div>
                  </div>}

                  <div className=''>
                    <div className='text-sm font-bold'>Time</div>
                    <div className='text-xs'>
                      {entry?.minutes && entry?.minutes !== null ? `${entry?.minutes} minutes` : `N/A`}
                    </div>
                  </div>

                  <div className='grid w-full gap-4'>
                    <div className=''>
                      <div className='text-sm font-bold'>Flag Status</div>
                      <div className='text-sm font-bold text-red-500'>{entryFlag.timesheetFlagStatus.name && entryFlag.timesheetFlagStatus.name !== null ? entryFlag.timesheetFlagStatus.name : 'N/A'}</div>
                    </div>
                  </div>

                  <div className=''>
                    <div className='text-sm font-bold'>Therapist Notes</div>
                    <div className='text-xs'>
                      <div>{entry?.notes}</div>
                    </div>
                  </div>
                </div>

                <div className='grid grid-cols-1 gap-4 mt-2 mb-2'>
                  <div className='w-full flex-column'>
                    <div className='text-sm font-bold'>Feedback <span className="text-red-500 sups">*</span></div>
                    <div className='w-full'>
                      <textarea
                        className='w-full'
                        onChange={(e) => { setFeedback(e.currentTarget.value) }}
                        value={feedback ?? ''}
                      />
                    </div>
                  </div>
                </div>
              </Fragment>
            )}

          </Fragment>
        </EditModal>

        {/* Timesheet Flag Review Modal */}
        <EditModal
          open={openTimesheetFlagModal}
          //onSave={() => { approveTimesheetFlag.run(); setOpenTimesheetFlagModal(false); }}
          saveText='Reject'
          saveColor='text-white bg-red-500 hover:bg-red-500'
          onSave={() => { rejectTimesheetFlag.run(); setOpenTimesheetFlagModal(false); }}
          allowSave={feedback !== null && feedback !== undefined && feedback !== ''}
          onCancel={() => { setFeedback(''); setOpenTimesheetFlagModal(false) }}
        >
          <div className=''>
            <h3>Review Entry</h3>
            <div className='grid grid-cols-3 gap-4 mt-2'>
              <div className=''>
                <div className='text-sm font-bold'>Therapist</div>
                <div className='text-xs'>
                  <div>{timesheet?.therapist?.user?.lastName}, {timesheet?.therapist?.user?.firstName}</div>
                  <div className='italic'>{timesheet?.therapist?.discipline?.name}</div>
                </div>
              </div>
              <div className=''>
                <div className='text-sm font-bold'>Location</div>
                <div>
                  <div className='text-sm'>{timesheet?.district?.name ?? task?.subTitle}</div>
                  <div className='text-xs italic'>{task?.programName}</div>
                  <div className='text-xs italic'>{task?.schoolName}</div>
                </div>
              </div>
              <div className=''>
                <div className='text-sm font-bold'>Rule</div>
                <div className='text-sm font-bold text-red-500'>
                  {((timesheetFlag && timesheetFlag !== undefined) &&
                    (timesheetFlag.proofingRule && timesheetFlag.proofingRule !== undefined) ?
                    timesheetFlag.proofingRule.name : '')}
                </div>
              </div>
            </div>

            {/*<div className='grid grid-cols-3 gap-4 mt-2'>
              <div className=''>
                <div className='text-sm font-bold'>Task Type</div>
                <div className='text-xs'>
                  {task?.taskTypeName !== '' ? task?.taskTypeName : 'N/A'}
                </div>
              </div>
            </div>

            <div className='grid grid-cols-3 gap-4 mt-2'>
              <div className=''>
                <div className='text-sm font-bold'>Time</div>
                <div className='text-xs'>
                  {entry?.minutes && entry?.minutes !== null ? `${entry?.minutes} minutes` : `N/A`}
                </div>
              </div>
            </div>*/}

            <div className='grid w-full gap-4 mt-2'>
              <div className=''>
                <div className='text-sm font-bold'>Flag Status</div>
                <div className='text-sm font-bold text-red-500'>{timesheetFlag?.proofingRule.name && timesheetFlag?.proofingRule.name !== null ? timesheetFlag?.proofingRule.name : 'N/A'}</div>
              </div>
            </div>

            <div className='grid grid-cols-1 gap-4 mt-2 mb-2'>
              <div className='w-full flex-column'>
                <div className='text-sm font-bold'>Feedback <span className="text-red-500 sups">*</span></div>
                <div className='w-full'>
                  <textarea
                    className='w-full'
                    onChange={(e) => { setFeedback(e.currentTarget.value) }}
                    value={feedback ?? ''}
                  />
                </div>
              </div>
            </div>
          </div>
        </EditModal>

        {/* Timesheet Rejection With Feedback Modal */}
        <EditModal
          open={openTimesheetRejectionModal}
          saveText='Reject'
          saveColor='text-white bg-red-500 hover:bg-red-500'
          onSave={() => { rejectTimesheet.run(); setOpenTimesheetRejectionModal(false); }}
          allowSave={feedback !== null && feedback !== undefined && feedback !== ''}
          onCancel={() => { setFeedback(''); setOpenTimesheetRejectionModal(false) }}
        >
          <div className=''>
            <h3>Reject Timesheet</h3>
            <div className='grid grid-cols-3 gap-4 mt-2'>
              <div className=''>
                <div className='text-sm font-bold'>Therapist</div>
                <div className='text-xs'>
                  <div>{timesheet?.therapist?.user?.lastName}, {timesheet?.therapist?.user?.firstName}</div>
                  <div className='italic'>{timesheet?.therapist?.discipline?.name}</div>
                </div>
              </div>
              <div className=''>
                <div className='text-sm font-bold'>Location</div>
                <div>
                  <div className='text-sm'>{timesheet?.district?.name ?? task?.subTitle}</div>
                  <div className='text-xs italic'>{task?.programName}</div>
                  <div className='text-xs italic'>{task?.schoolName}</div>
                </div>
              </div>
            </div>

            <div className='grid grid-cols-1 gap-4 mt-2 mb-2'>
              <div className='w-full flex-column'>
                <div className='text-sm font-bold'>Feedback <span className="text-red-500 sups">*</span></div>
                <div className='w-full'>
                  <textarea
                    className='w-full'
                    onChange={(e) => { setFeedback(e.currentTarget.value) }}
                    value={feedback ?? ''}
                  />
                </div>
              </div>
            </div>
          </div>
        </EditModal>

        <div className='w-full mt-2'>
          <div className='p-3 ml-5 bg-white rounded-lg shadow'>
            {/* Timesheet Flags Notification */}
            {timesheet?.timesheetFlags &&
              timesheet?.timesheetFlags !== undefined &&
              timesheet?.timesheetFlags.length > 0 &&
              timesheet?.timesheetFlags[0].proofingRule !== null &&
              timesheet?.timesheetFlags.filter(x => x.timesheetFlagStatusId === TimesheetFlagStatus.Generated).length > 0 &&
              <Notification isSuccess={false}>
                <ul className='pl-5 list-disc'>
                  {timesheet?.timesheetFlags
                    .filter(x => x.timesheetFlagStatusId === TimesheetFlagStatus.Generated)
                    .map((timesheetFlag: TimesheetFlag) => (
                      <Fragment key={`timesheet-flag-${timesheetFlag.timesheetFlagId}`}>
                        {((timesheetFlag && timesheetFlag !== undefined) &&
                          (timesheetFlag.proofingRule && timesheetFlag.proofingRule !== null) ?
                          <li>
                            <span
                              className='font-bold text-white underline cursor-pointer hover:text-black'
                              onClick={() => {
                                handleTimesheetFlagModal(timesheetFlag);
                              }}>
                              {timesheetFlag.proofingRule.name}
                            </span>
                            <span> -- Created: {moment(timesheetFlag.dateFlagged).format('l')}</span>
                            <div className="quick-actions-div">
                              <a href="#" onClick={() => {
                                handleQuickApprove(timesheetFlag);
                              }}>Approve</a>|
                              <a href="#" onClick={() => {
                                handleQuickReject(timesheetFlag);
                              }}>Reject</a>|
                              <a href="#" onClick={() => {
                                handleTimesheetFlagModal(timesheetFlag, true);
                              }}>Reject With Feedback</a>
                            </div>
                          </li>
                          :
                          <></>
                        )
                        }
                      </Fragment>
                    ))}
                </ul>
              </Notification>
            }
            {(
              <div className="text-right"><a href="#" onClick={(e) => {
                e.preventDefault();
                if (switchLabel == "Switch to List View") {
                  setActiveView("list");
                  setSwitchLabel("Switch to Grid View");
                  setWeek(week);
                } else {
                  setActiveView("grid");
                  setSwitchLabel("Switch to List View");
                }
              }}>{switchLabel}</a></div>
            )}

            {/**
             *  Week (Timesheet) Display (List)
             ***/}
            {week && (activeView === "list") && (
              <Fragment key="list-view">
                <div className='inline-block w-1/2'>
                  <div className='h-3 text-sm text-gray-500'>Timesheet For:</div>
                  <div className='h-3 mt-1 mb-5 text-lg font-bold text-black'>{`${timesheet?.therapist?.user?.lastName}, ${timesheet?.therapist?.user?.firstName}`}</div>
                  <div className='text-2xl font-bold h-7'>{moment(week.firstDayOfWeek).format("MMMM D")} - {moment(week.lastDayOfWeek).format("D")}</div>
                  <div className='font-bold'>{timesheet?.year}</div>
                  <div className='text-2xl font-bold h-7'>{discipline}</div>
                </div>
                <div className='inline-block w-1/2'>
                  <button
                    className={`text-sm float-right ${timesheet?.timesheetStatusId === TimesheetStatus.Rejected ? 'bg-orange-500 cursor-not-allowed' : 'bg-red-500 hover:bg-red-700'} text-white py-1 ml-5`}
                    onClick={(e) => { setOpenTimesheetRejectionModal((timesheetStatusId && timesheetStatusId > -1 ? timesheetStatusId : timesheet?.status.timesheetStatusId) !== TimesheetStatus.Rejected) }}
                  >
                    {(timesheetStatusId && timesheetStatusId > -1 ? timesheetStatusId : timesheet?.status.timesheetStatusId) === TimesheetStatus.Rejected ? 'Timesheet Rejected' : 'Reject Timesheet'}
                  </button>
                  <button
                    className='float-right py-1 text-sm bg-ptsblue-light hover:bg-ptsblue-normal'
                    onClick={() => {
                      let stateParams: any = { year: moment(week.firstDayOfWeek).format("YYYY"), month: moment(week.firstDayOfWeek).format("M") };
                      history.push(`/proofing`, stateParams);
                    }}
                  >
                    Go Back
                  </button>
                </div>
                <div className='z-0 px-4 py-5 bg-white sm:p-6'>
                  <div className='z-0 grid grid-cols-6 gap-6'>
                    <div className='col-span-6 sm:col-span-3 lg:col-span-2'>
                      <label className='primary'>District</label>
                      <SelectMulti
                        className='block primary'
                        isMulti={false}
                        options={districtOptions}
                        isClearable={true}
                        onChange={(e: any | null) => {
                          //Null exception handling
                          e = (e !== null) ? e : { label: '', value: "-1" };
                          setDistrict(e.value);
                        }}
                      />
                    </div>
                    <div className='col-span-6 sm:col-span-3 lg:col-span-2'>
                      <label className='primary'>Flag</label>
                      <SelectMulti
                        className='block primary'
                        isMulti={false}
                        options={flagOptions}
                        isClearable={true}
                        onChange={(e: any | null) => {
                          //Null exception handling
                          e = (e !== null) ? e : { label: '', value: "-1" };
                          setFlag(e.value);
                        }}
                      />
                    </div>
                    <div className='col-span-6 sm:col-span-3 lg:col-span-2'>
                      <label className='primary'>School</label>
                      <SelectMulti
                        className='block primary'
                        isMulti={false}
                        options={schoolOptions}
                        isClearable={true}
                        onChange={(e: any | null) => {
                          //Null exception handling
                          e = (e !== null) ? e : { label: '', value: "-1" };
                          setSchool(e.value);
                        }}
                      />
                    </div>

                  </div>
                </div>
                <div className='flex px-4 py-3 text-right bg-gray-50 sm:px-6'>
                  <SubmitButton
                    text='Search'
                    className='mr-5 bg-ptsblue-normal hover:bg-ptsblue-dark'
                    onClick={() => {
                      //handleSearchAsync.run();
                      handleSearch();
                    }}
                  />
                </div>
                <div className='p-3 mt-5 bg-white rounded-lg shadow'>
                  <button className="mr-5 bg-ptsblue-normal hover:bg-ptsblue-dark"
                    disabled={selectedCount === 0}
                    onClick={() => {
                      approveMulti.run();
                    }}
                  >
                    Approve Selected
                  </button>
                  <button className="mr-5 bg-ptsblue-normal hover:bg-ptsblue-dark"
                    disabled={selectedCount === 0}
                    onClick={() => {
                      rejectMulti.run();
                    }}
                  >
                    Reject Selected
                  </button>
                  <div className='mt-5'>
                    <DataTable
                      columns={columns}
                      data={flags}
                      showPagination={true}
                      initialState={initialState}
                      resetOnDataChange={false}
                      getRowProps={(row: any) => ({
                        className: row.original.isMyMessage
                          ? 'cursor-pointer hover:bg-purple-300 bg-purple-200'
                          : 'cursor-pointer hover:bg-gray-100',
                        onClick: () => { }
                        //history.push(`/admin/districts/${row.values.districtId}`),
                      })}
                    />
                  </div>
                </div>
              </Fragment>
            )}

            {/**
             *  Week (Timesheet) Display (Grid)
             ***/}
            {week && (activeView === "grid") && (
              <Fragment key="grid-view">
                <div className='inline-block w-1/2'>
                  <div className='h-3 text-sm text-gray-500'>Timesheet For:</div>
                  <div className='h-3 mt-1 mb-5 text-lg font-bold text-black'>{`${timesheet?.therapist?.user?.lastName}, ${timesheet?.therapist?.user?.firstName}`}</div>
                  <div className='text-2xl font-bold h-7'>{moment(week.firstDayOfWeek).format("MMMM D")} - {moment(week.lastDayOfWeek).format("D")}</div>
                  <div className='font-bold'>{timesheet?.year}</div>
                  <div className='text-2xl font-bold h-7'>{discipline}</div>
                </div>
                <div className='inline-block w-1/2'>
                  <button
                    className={`text-sm float-right ${timesheet?.status.timesheetStatusId === TimesheetStatus.Rejected ? 'bg-orange-500 cursor-not-allowed' : 'bg-red-500 hover:bg-red-700'} text-white py-1 ml-5`}
                    onClick={(e) => { setOpenTimesheetRejectionModal(true) }}
                  >
                    {(timesheetStatusId && timesheetStatusId > -1 ? timesheetStatusId : timesheet?.status.timesheetStatusId) === TimesheetStatus.Rejected ? 'Timesheet Rejected' : 'Reject Timesheet'}
                  </button>
                  <button
                    className='float-right py-1 text-sm bg-ptsblue-light hover:bg-ptsblue-normal'
                    onClick={() => {
                      let stateParams: any = { year: moment(week.firstDayOfWeek).format("YYYY"), month: moment(week.firstDayOfWeek).format("M") };
                      history.push(`/proofing`, stateParams);
                    }}
                  >
                    Go Back
                  </button>
                </div>
                <div>
                  <TimesheetWeekEntries
                    week={week}
                    timesheet={timesheet}
                    displayFlags={true}
                    allowEdit={true}
                    editEntry={(weekItem) => { handleModal(weekItem, false); }} />

                  <ProofingNotes
                    approvalHandler={approveProofingNote}
                    className={`mt-8`}
                    header="Notes"
                    modalHandler={handleModal}
                    showOnlyRejected={false}
                    week={week}
                  />
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </>
    </Layout>
  );
};

export default ProofingDetail;

